<template>
    <div class="app has-header">
        <div class="header main">
            
            <div class="align-left">
                
            </div>
            <div class="align-middle">
               <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
            </div>
        </div>
        <div class ="tablecontainer scrollbar-container">
            <h2>{{ $t('store.notifications.title') }}</h2>
            <datatable :state="dataTableState"/>
            <br/>
            <h2>MeineLohnabrechnung {{ $t('store.notifications.title') }}</h2>
            <datatable :state="mlEmailNotificationDataTableState"/>
        </div>  
      
      
    <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
  </div>

</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'emailnotificationoverview',
    components: {
        datatable,
    },
  data () {
    return {

        error: false,
        loading: true,
        loadingText: null,
        mlNotificationEmailMap: {},
    }
  },
  
    created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'storeSettings', 'emailNotificationMap', 'mlEmailNotificationMap', 'isSuperUser', 'uiDataMap']),
        headerButtons(){

            let view = this;

            let state= {
                buttons: []
            };
            //BUTTON 1
            state.buttons.push({
                type: "block",
                icon: "fa-sync-alt",
                click: () => {
                    view.refresh(true); 
                },
                tooltip: this.$t('global.general.refreshData')
            });
            state.buttons.push({
                type: "block green",
                 icon: "fa-plus",
                 click: ($event) => {
                    view.OpenCreateEmailNotificationModal($event);
                 },
                 tooltip: this.$t('store.notifications.new'),
                helperText: this.$t('store.notifications.newHelp')
               
            });
            state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close'),
                    }
                ];
            return state;
        },
        
       
        dataTableState(){
            let view = this;
            
            let state = {};
            
            let values = Object.values(this.emailNotificationMap);

            state = this.$helpers.GetDataTableStateFromObject({email: '', type: ''},values);

            state.headerMap['email'].sort = true;
            state.headerMap['email'].label = this.$t('pages.employeeData.email');

            state.headerMap['type'].sort = true;
            state.headerMap['type'].label = this.$tc('global.general.type');
            state.headerMap['type'].DisplayLabel = (i) => {
              return this.uiDataMap.emailNotificationTypes.find(e => e.id === i.type) ?
                  this.uiDataMap.emailNotificationTypes.find(e => e.id === i.type).label_de : '-'
            };


            state.headerMap['actions'] = {align: 'center',
                button: null,
                buttons:[
                    {icon: 'fas fa-edit', action: ($event, data) => view.OpenEditEmailNotificationModal($event, data)}, 
                    {icon: 'fas fa-trash', action: ($event, data) => view.OpenDeleteEmailNotificationModal($event, data)},
                ]
            };
            state.headerMap['actions'].width = '100px';


            return state;
        },
        mlEmailNotificationDataTableState(){
            let view = this;

            let state = {};

            let values = Object.values(this.mlEmailNotificationMap).sort((a, b) => a.notificationEventId - b.notificationEventId);

            state = this.$helpers.GetDataTableStateFromObject({email: '', notificationEventId:''},values);

            let labelMap = {
                "1": this.$t('pages.employeeCoreData.newEmployee'),
                "2": this.$t('store.notifications.monthlyClosingFinished'),
                "3": this.$t('store.notifications.monthlyClosingOpened'),
                "4": this.$t('store.notifications.sotecExportError'),
                "5": this.$t('store.notifications.contractTerminated'),
                "6": this.$t('store.notifications.sotecPreCheck'),
            }


            state.headerMap['email'].sort = false;
            state.headerMap['email'].label = this.$t('pages.employeeData.email');

            state.headerMap['notificationEventId'].sort = false;
            state.headerMap['notificationEventId'].label = this.$tc('global.general.type');
            state.headerMap['notificationEventId'].DisplayLabel = (i) => {
                return labelMap[i.notificationEventId] ? labelMap[i.notificationEventId] : '-'
            };


            return state;
        }
    },
    watch: {
        storeId: function(val, oldVal) {
            this.refresh(true);
        },
    },
    // methods that implement data logic.
    methods: {
        refresh: function(force = false) {
            let view = this;
            this.loading = true;
            this.$helpers.GetUiDataMap(force);
            this.$helpers.GetEmailNotificationMap(force)
            .then(map=>{
                return new Promise((resolve, reject) => {
                    view.$helpers.GetMlEmailNotificationMap(force).then(d => {
                        resolve(d)
                    }).catch(e => {
                        resolve({});
                    })
                })
            })
            .then(map=>{

                view.loading = false;
            })
            .catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                view.loading = false;
                console.log(error)
            });
        },
        OpenCreateEmailNotificationModal($event){
            let view = this;

            let citems = Object.values(this.uiDataMap.emailNotificationTypes)
            .filter(e => {
                return view.storeSettings.enableAppShiftStatus || e.id > 3;
            })
            .map(e => {return {label: e.label_de, value: e.id}});
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                          toggled: false,
                          displayedItems: [],
                          input: '',
                          items: citems,
                          selectMultiple: false,
                          selectedItems: [],
                          selectFirst: true,
                          styleLight: true,
                        }},
                        {label: this.$t('pages.employeeData.email'), key: 'email', hidden: false, type: 'text', value: null},
                    ],
                    selectCallback: function (data) {
                        view.createEmailNotification(data);
                    }
                },
                header: this.$t('store.notifications.newEmail'),
                centered: true,
                expanded: true,
            });
        },
        createEmailNotification: function(item){
            let view = this;
            let url = '/api/sec/emailnotification';
            let params = {
                storeId: this.storeId,
            }


            let payload = {
                storeId: this.storeId,
                type: item.type,
                email: item.email,
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setEmailNotificationMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.notifications.newCreated'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.notifications.newCreatedError'));
                console.log(error)
            })

        },
        OpenSendMessageModal($event){
            let view = this;
            let citems = Object.values(this.contactPersonMap).map(item => {return {label: item.name, value: item.id}});
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: this.$t('store.notifications.contact'), key: 'id', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: citems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            styleLight: true,
                        }},
                        {label: this.$t('store.notifications.subject'), key: 'subject', hidden: true, type: 'text', value: 'Anfrage'},
                        {label: this.$t('store.notifications.message'), key: 'message', hidden: false, type: 'text', value: ''},
                    ],
                    selectCallback: function (data) {
                        view.sendMessage(data);
                    }
                },
                header: this.$t('store.notifications.notifyContact'),
                centered: true,
                expanded: true,
            });
        },
        sendMessage: function(item){
            let view = this;
            let url = '/api/sec/contactperson/message';
            let params = {
                storeId: this.storeId,
            }


            let payload = {
                storeId: this.storeId,
                id: item.id,
                subject: item.subject,
                message: item.message
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.contact.messaged'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.contact.messageError'));
                console.log(error)
            })

        },

        OpenDeleteEmailNotificationModal($event, data){
            let view = this;
            view.$helpers.OpenAlert({header: this.$t('store.notifications.delete'), description: this.$t('store.notifications.deleteQuery'), callbackAccept: (alert) => {
                alert.hidden = true;
                view.deleteEmailNotification(data);
            }});
        },
        deleteEmailNotification: function(item){
            let view = this;
            let url = '/api/sec/emailnotification';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteEmailNotificationMapEntry", {id: item.id});
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.notifications.deleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.notifications.deleteError'));
                console.log(error)
            })

        },
        OpenEditEmailNotificationModal($event, item){
            let view = this;

            let citems = Object.values(this.uiDataMap.emailNotificationTypes).map(e => {return {label: e.label_de, value: parseInt(e.id)}});
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id},
                        {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                          toggled: false,
                          displayedItems: [],
                          input: '',
                          items: citems,
                          selectMultiple: false,
                          selectedItems: [],
                          selectedItem: citems.find(i => i.value === item.type),
                          selectFirst: false,
                          styleLight: true,
                        }},
                        {label: this.$t('pages.employeeData.email'), key: 'email', hidden: false, type: 'text', value: item.email},
                    ],
                    selectCallback: function (indicatorType) {
                        view.editEmailNotification(indicatorType);
                    },
                    
                },
                header: this.$t('store.notifications.edit'),
                centered: true,
                expanded: true,
            });
        },
        editEmailNotification: function(item){
            let view = this;
            let url = '/api/sec/emailnotification';
            let params = {
                
                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                type: item.type,
                email: item.email,
                updateFields: ["type", "email"]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.emailNotificationMap[item.id]
                data.type = payload.type;
                data.email = payload.email;

                view.$store.commit("setEmailNotificationMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('store.notifications.edited'));
            }).catch(function (error) {
               view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.notifications.editError'));
               console.log(error)
            })

        }
        
        
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }
 
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .header.date{
        display: inline-flex;
        justify-items: center;
        align-items: center;
        position: absolute;
        left: 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
        margin-top: -3px;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin-right: 5px;
        margin-top: -3px;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
        margin-top: -3px;
    }
    .header.date .fa-angle-left{
        margin: 0 10px;
        font-size: 25px;
        color: var(--contrast-4);
    }
    .indicator-view{
        padding: 30px;
        padding-bottom: 50px;
    }
</style>
